import { IconButton } from "@mui/material";

import { Container, Prefix, Suffix } from "./Badge.styles";
import { BadgeProps } from "./Badge.types";
import { XCloseIcon } from "../Icon";

const Badge: React.FC<BadgeProps> = ({
  children,
  closable,
  color,
  dot,
  prefix,
  size = "medium",
  suffix,
  type,
  variant,
  onClose,
}) => {
  return (
    <Container
      color={color}
      dot={dot}
      size={size}
      type={type}
      variant={variant}
      withCloseable={closable}
      withPrefix={!!prefix}
      withSuffix={!!suffix}
    >
      {prefix ? <Prefix className="badge-prefix">{prefix}</Prefix> : null}
      {children}
      {suffix ? <Suffix className="badge-suffix">{suffix}</Suffix> : null}
      {closable ? (
        <Suffix className="badge-suffix">
          <IconButton onClick={onClose}>
            <XCloseIcon color="inherit" />
          </IconButton>
        </Suffix>
      ) : null}
    </Container>
  );
};

export default Badge;
